import Cookies from "js-cookie";
import { jwtDecode, JwtPayload } from "jwt-decode";
import moment from "moment";
import { toast } from "react-toastify";
import {
  ADDRESS_COOKIE_KEY,
  barColors,
  CART_COOKIE_KEY,
  customer,
  doctorMode,
} from "../lib/constans";
import {
  IAddressData,
  ICartItems,
  ILatestChat,
  ProductSortType,
  TimeSlot,
} from "../types/GlobalInterfaces";
import httpRequest from "./httpRequest";
import qs from "qs";
import { setChatList } from "src/Store/chat";
import { Dispatch } from "react";

// Define a custom interface for the decoded JWT payload
export interface ICustomJwtPayload extends JwtPayload {
  userRole?: string | undefined; // Adjust the type if necessary
  userName?: string | undefined;
  exp: number;
  isGoogle?: boolean;
  isVerified?: boolean;
  [key: string]: any;
}

export const decodedToken = (_token: string | undefined = getToken()) => {
  // console.log("ecodable Token", _token);
  const token = _token || getToken();
  if (token) {
    let decoded = jwtDecode<ICustomJwtPayload>(token);
    return decoded;
  } else {
    return undefined;
  }
};

export const generateRandomId = () => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < 30; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
};
// Set the token in cookies with expiration handling
export const setToken = (token: string): void => {
  const decodedToken = jwtDecode<ICustomJwtPayload>(token);
  // console.log("decodedToken", decodedToken);
  // Get the expiration time from the token's 'exp' claim
  const expirationTime = decodedToken.exp * 1000; // Convert to milliseconds
  const cookieOptionsCross = {
    expires: new Date(expirationTime),
    path: "/",
    // domain: process.env.REACT_APP_DOMAIN, // Add domain here
    // secure: true,
  };
  Cookies.set(process.env.REACT_APP_TOKEN as string, token, cookieOptionsCross);
};

// Get the token from cookies
export const getToken = (): string | undefined => {
  return Cookies.get(process.env.REACT_APP_TOKEN as string);
};

export const getShippingAddresses = (): IAddressData | string | null => {
  const arr = Cookies.get(ADDRESS_COOKIE_KEY);
  try {
    return arr ? JSON.parse(arr) : null;
  } catch (err) {
    return "Karachi, Pakistan";
  }
};

export const setShippingAddresses = (address: IAddressData | string | null) => {
  if (!address) {
    Cookies.remove(ADDRESS_COOKIE_KEY);
  } else {
    Cookies.set(ADDRESS_COOKIE_KEY, JSON.stringify(address));
  }
  return address;
};

export const convertToApiSortKey = (sort: ProductSortType) => {
  switch (sort) {
    case "most-popular":
      return "mostPopular";
    case "most-rated":
      return "mostRated";
    case "price-low-to-high":
      return "lowToHigh";
    case "price-high-to-low":
      return "highToLow";
    default:
      return "mostPopular";
  }
};

export const printAddress = (
  address: IAddressData | null | string,
  truncate = true
) => {
  // console.log("Print Address ===> ", address);
  if (!address) return "Karachi, Pakistan";
  if (typeof address === "string") {
    return address;
  }
  return `${
    truncate
      ? truncateString(address?.streetAddress || "", 40)
      : address?.streetAddress || ""
  }`;
};

export const removeToken = (): void => {
  console.log("removeToken_system_remove");
  Cookies.remove(process.env.REACT_APP_TOKEN as string);
  Cookies.remove(doctorMode);
};

// truncate string
export const truncateString = (
  str: string = "",
  limit: number = 10
): string => {
  if ((str ? str.length : 0) > limit) {
    return `${str.slice(0, limit)}...`;
  } else {
    return str;
  }
};

// Validate email using regex
export const validateEmail = (email: string) => {
  // email regex for validate email
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Validate password using regex
export const validatePassword = (password: string) => {
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+]{8,}$/;
  return passwordRegex.test(password);
};

export const generateRandomKey = (): string => {
  const getRandomHex = (length: number) => {
    let result = "";
    const characters = "0123456789abcdef";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  };

  return getRandomHex(24); // MongoDB ObjectId is 24 hexadecimal characters
};

export const getLastSegment = (str: string): string => {
  if (!str) return "";
  const segments = str.split("-");
  return segments.length > 0 ? segments[segments.length - 1] : "";
};

// Get cart IDs from cookies
export const getCartItemsFromCookie = (): ICartItems[] => {
  const arr = Cookies.get(CART_COOKIE_KEY);
  return arr ? JSON.parse(arr) : [];
};

// Set cart IDs to cookies
export const setCartItemsToCookie = (items: ICartItems[]) => {
  const cookieOptionsCross = {
    expires: 7,
    path: "/",
    domain: process.env.REACT_APP_DOMAIN,
  };
  Cookies.set(
    CART_COOKIE_KEY as string,
    JSON.stringify(items),
    cookieOptionsCross
  );
};

export const displayStatus = (
  txt: string
): { text: string; bgColor: string; color: string } => {
  switch (txt) {
    case "pending":
      return { text: "Pending", bgColor: "#FFE8A2", color: "#FFC107" };
    case "delivered":
      return { text: "Delivered", bgColor: "#B8DAFF", color: "#007BFF" };
    case "deleted":
      return { text: "Deleted", bgColor: "#E64F4F", color: "#8B0000" };
    case "declined":
      return { text: "Deleted", bgColor: "#E64F4F", color: "#8B0000" };
    case "cancelled":
      return { text: "Cancelled", bgColor: "#FE8989", color: "#FF0000" };
    case "completed":
      return { text: "Completed", bgColor: "#ACE6B9", color: "#28A745" };
    default:
      return { text: "", bgColor: "transparent", color: "black" };
  }
};

export const ageCategory = (age: number): string => {
  if (age < 18) {
    return "child";
  } else if (age <= 50) {
    return "adult";
  } else {
    return "elder";
  }
};

export const returnColor = (color: string): string => {
  switch (color) {
    case "green":
      return barColors.green;
    case "yellow":
      return barColors.yellow;
    case "orange":
      return barColors.orange;
    case "red":
      return barColors.red;
    default:
      // return "#0c00ff";
      return "#21A3FF";
  }
};

// Form Validations Functions

export const validatePhoneNumber = (value: string) => {
  let val = value;

  // Allow only one '+' at the start, remove any additional '+' and non-digit characters
  let hasPlus = val.startsWith("+");
  if (hasPlus) {
    // Keep only the first '+' and remove all other '+' and non-digits
    val =
      "+" +
      val
        .slice(1)
        .replace(/\+/g, "")
        .replace(/[^0-9]/g, "");
  } else {
    // If no '+', remove all non-digits
    val = val.replace(/[^0-9]/g, "");
  }

  // Limit to max 13 characters, preserving the '+' if present
  if (val.length > 13) {
    if (hasPlus) {
      val = "+" + val.slice(1, 13); // Keep '+' and next 12 digits
    } else {
      val = val.slice(0, 13); // If no '+', take first 13 digits
    }
  }

  // Validate: Ensure only one '+' at the start (if present) and total length <= 13
  const isValid =
    val === "" ||
    (val.match(/\+/g)?.length === 1 && val.length <= 13) ||
    (!val.includes("+") && val.length <= 13);

  return {
    cleanedValue: val,
    isValid,
    message: isValid
      ? ""
      : "Phone number can only start with one '+' and have up to 12 digits (max 13 characters total).",
  };
};

/**
 * Validates and filters phone number according to the updated regex rules
 * - With +: must be exactly 12 digits after + (total 13 chars, e.g., +923001234567)
 * - Without +: must be exactly 11 digits (e.g., 03001234567)
 * @param value - Input phone number value
 * @returns Object with filteredValue and errorMessage
 */
export const validateAndFilterPhoneNumber = (value: string): {
  filteredValue: string;
  errorMessage: string;
} => {
  let filteredValue = value;
  const hasPlus = filteredValue.startsWith("+");

  // Filter: Keep only + at start and digits
  if (hasPlus) {
    filteredValue = "+" + value.slice(1).replace(/[^0-9]/g, "");
  } else {
    filteredValue = value.replace(/[^0-9]/g, "");
  }

  // Get digit count (excluding +)
  const digitCount = filteredValue.replace("+", "").length;

  // Set exact digits based on whether + is present
  const exactDigits = hasPlus ? 12 : 11;

  // Limit the length
  if (digitCount > exactDigits) {
    if (hasPlus) {
      filteredValue = "+" + filteredValue.slice(1, exactDigits + 1);
    } else {
      filteredValue = filteredValue.slice(0, exactDigits);
    }
  }

  // Determine error message
  let errorMessage = "";
  const finalDigitCount = filteredValue.replace("+", "").length;

  if (finalDigitCount > 0) {
    if (hasPlus) {
      // With +: must be exactly 12 digits after +
      if (finalDigitCount < 12) {
        errorMessage = "Phone number with + must be 12 digits after + (e.g., +923001234567)";
      }
    } else {
      // Without +: must be exactly 11 digits
      if (finalDigitCount < 11) {
        errorMessage = "Phone number must be exactly 11 digits (e.g., 03001234567)";
      }
    }
  }

  return {
    filteredValue,
    errorMessage,
  };
};

export const validateFirstName = (firstName: string) => {
  // Keep only letters and spaces, remove everything else
  let cleanedName = firstName.replace(/[^a-zA-Z\s]/g, "").trim();

  // Limit to max 50 characters
  if (cleanedName.length > 50) {
    cleanedName = cleanedName.slice(0, 50).trim();
  }

  // Return the cleaned string
  return cleanedName;
};

export const shortenFileName = (fileName: string, maxLength = 18) => {
  // Handle edge cases
  if (!fileName || typeof fileName !== "string") return fileName;

  // Split the file name into name and extension
  const lastDotIndex = fileName.lastIndexOf(".");
  let name = fileName;
  let extension = "";

  if (lastDotIndex !== -1) {
    name = fileName.substring(0, lastDotIndex);
    extension = fileName.substring(lastDotIndex); // Includes the dot (e.g., '.png')
  }

  // If the name is shorter than or equal to maxLength, return the original file name
  if (name.length <= maxLength) {
    return fileName;
  }

  // Calculate how many characters to show at the start and end
  const charsToShow = Math.floor((maxLength - 2) / 2); // Subtract 2 for the '..'
  const start = name.substring(0, charsToShow);
  const end = name.substring(name.length - charsToShow);

  // Return the shortened name with '..' in the middle
  return `${start}...${end}${extension}`;
};

export const validateAddress = (address: string) => {
  // Import the regex from constants
  const { streetAddressRegex } = require("../lib/constans");
  
  // Check if address is empty or just whitespace
  if (!address || address.trim() === "") {
    return { isValid: false, message: "Address cannot be empty." };
  }

  // Check for specific invalid characters
  if (address.includes(':') || address.includes(';')) {
    return {
      isValid: false,
      message: "Address cannot contain colons (:) or semicolons (;)",
    };
  }

  // Check for junk symbols (excluding plus sign which is allowed)
  if (/[@^&*()_={}[\]|\\:";'<>?~`]/.test(address)) {
    return {
      isValid: false,
      message: "Address cannot contain special symbols like @, ^, &, etc.",
    };
  }

  // Check minimum length
  if (address.trim().length < 10) {
    return {
      isValid: false,
      message: "Address must be at least 10 characters long",
    };
  }

  // Use the centralized regex validation
  if (!streetAddressRegex.test(address)) {
    return {
      isValid: false,
      message: "Address should contain only letters, numbers, spaces, commas, periods, dashes, slashes, hash (#), and plus (+) (10-100 characters)",
    };
  }

  return { isValid: true, message: "Address is valid." };
};

export const validateDoctorLicense = (licenseNumber: string) => {
  // Remove all except letters, numbers, hyphens, and dots
  let cleanedLicense = licenseNumber.replace(/[^A-Z0-9./-]/g, "").trim();

  // Limit to max 15 characters
  if (cleanedLicense.length > 15) {
    cleanedLicense = cleanedLicense.slice(0, 15);
  }

  // Minimum character check (e.g. at least 6)
  if (cleanedLicense.length < 6) {
    return {
      success: false,
      message: "PMDC registration number must be at least 6 characters long",
      cleanedLicense,
    };
  }

  // PMDC number format validation
  // PMDC numbers typically follow pattern: 12345-P or 12345-P/MED or similar
  const pmdcPattern = /^[0-9]{1,5}-[A-Z](\/[A-Z]+)?$/;

  if (!pmdcPattern.test(cleanedLicense)) {
    return {
      success: false,
      message:
        "Invalid PMDC registration number format. Expected format: 12345-P or 12345-P/MED",
      cleanedLicense,
    };
  }

  // Check if number part is reasonable (1-99999)
  const numberPart = cleanedLicense.split("-")[0];
  const numberValue = parseInt(numberPart);

  if (numberValue < 1 || numberValue > 99999) {
    return {
      success: false,
      message: "PMDC registration number should be between 1-99999",
      cleanedLicense,
    };
  }

  // If valid
  return {
    success: true,
    cleanedLicense,
    message: "",
  };
};

export function validatePassportId(passportId: string) {
  const passportRegex = /^[A-Z]{1,2}\d{4,8}$/;

  if (passportRegex.test(passportId)) {
    return true;
  } else {
    return false;
  }
}

// Form validations End

/**
 * Converts a number of months into a human-readable format.
 *
 * @param {number} totalMonths - The total number of months to convert.
 * @returns {string} The formatted string representing the number of years and months.
 */
export const convertMonthsToReadableFormat = (totalMonths: number): string => {
  if (totalMonths < 0 || isNaN(totalMonths) || totalMonths === undefined) {
    console.log("Total months cannot be negative.");
    return "";
  }

  if (totalMonths == 0) {
    return "No Experience";
  }

  const years = Math.floor(totalMonths / 12);
  const months = totalMonths % 12;

  let result = "";
  if (years > 0) {
    result += `${years.toString().padStart(2, "0")} year${
      years > 1 ? "s" : ""
    }`;
  }
  if (months > 0) {
    if (result) {
      result += " ";
    }
    result += `${months.toString().padStart(2, "0")} month${
      months > 1 ? "s" : ""
    }`;
  }

  return result || "Less Than One Year";
};

export const capitalize = (str: string): string => {
  if (!str) return ""; // Handle empty strings
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const downloadFile = (url: string) => {
  try {
    if (!url) {
      throw new Error("File name could not be extracted from the URL.");
    }
    // Extract the filename from the URL
    const fileName: string = url.split("/").pop() || ""; // Get the last part of the URL
    fetch(`${url}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch the file.");
        }
        return response.blob();
      })
      .then((blob) => {
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", fileName); // Use extracted filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Cleanup the link element
        window.URL.revokeObjectURL(blobUrl); // Cleanup the object URL
      })
      .catch((error) => console.error("Download failed:", error));
  } catch (err: any) {
    toast(err?.message || "ERROR", { type: "error" });
  }
};

export const convertToTimeAgo = (dateString: string): string => {
  const now = moment(); // Current time
  const inputTime = dateString ? moment(dateString) : moment(); // Input date-time

  const duration = moment.duration(now.diff(inputTime)); // Difference between now and the input time

  const days = duration.days();
  const hours = duration.hours();
  const minutes = duration.minutes();
  const seconds = duration.seconds();

  if (days > 0) {
    return `${days} days ago`;
  }
  if (hours > 0) {
    return `${hours} hours ago`;
  }
  if (minutes > 0) {
    return `${minutes} minutes ago`;
  }
  // Handle cases where the difference is less than a minute
  if (seconds > 0 || duration.asSeconds() <= 0) {
    return `few seconds ago`;
  }
  return `few seconds ago`; // Fallback for any other edge cases
};

export const getInitialsImage = (
  name: string = "",
  size: number = 0,
  fontSize: number = 16,
  bgColor: string = "#006ADB"
) => {
  const nameParts = name.split(" ");
  const firstInitial = nameParts[0]?.charAt(0).toUpperCase();
  const lastInitial = nameParts[1]?.charAt(0).toUpperCase() || "";
  // Generate a fallback image with initials as a data URL
  const initials = `${firstInitial}${lastInitial}`;
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  canvas.width = size;
  canvas.height = size;
  if (context) {
    // Draw circle background
    context.fillStyle = bgColor; // background color
    context.fillRect(0, 0, canvas.width, canvas.height);
    // Set text properties
    context.font = `${fontSize}px sans-serif`;
    context.fillStyle = "#FFFFFF"; // text color
    context.textAlign = "center";
    context.textBaseline = "middle";
    context.fillText(initials, canvas.width / 2, canvas.height / 2);
  }
  return canvas.toDataURL(); // Convert canvas to image data URL
};

export const convertToHyperlinks = (inputText: string = ""): string => {
  // Regular expression to detect URLs
  const urlRegex =
    /(\b(https?:\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|]))/gi;

  // Replace URLs in the text with an anchor tag that opens in a new tab
  const formattedText = inputText.replace(urlRegex, (url) => {
    return `<a href="${url}" target="_blank" class="underline text-[#0000EE]" rel="noopener noreferrer">${url}</a>`;
  });

  return formattedText;
};

export const calcualteTotalPrice = (
  data: { salePrice: number; regularPrice: number; quantity: number }[] = []
): number => {
  const _total = data?.reduce((prev, current) => {
    const price = current?.salePrice || current?.regularPrice;
    return prev + (current?.quantity * price || 0);
  }, 0);
  return Number(_total.toFixed(2)) || 0;
};

export function print2DigitNumber(num: number): string {
  // Check if the number has a decimal part
  if (num % 1 !== 0) {
    // If it has a decimal, show only 3 digits after the decimal
    return num.toFixed(2);
  }
  // If it's a whole number, return it as is
  return num.toString();
}

export const printServiceDuration = (
  txt: "1Hour" | "2Hour" | "3Hour" | string
): string => {
  switch (txt) {
    case "1Hour":
      return "1 Hour";
    case "2Hour":
      return "2 Hour";
    case "3Hour":
      return "3 Hour";
    default:
      return "";
  }
};

export const canWrite = (
  userDetails: any,
  resourceKey: string,
  showToast = false
): boolean => {
  // 1) If no role object or userDetails -> no access
  const roleObj = userDetails?.userRoleId;
  if (!roleObj) {
    if (showToast) toast.error("No role data found.");
    return true;
  }

  // 2) If super admin, always grant permission
  if (userDetails?.isSuperAdmin || roleObj?.roleName === "superAdmin") {
    return true;
  }

  // 3) Otherwise, check if field for that resource is "read/write"
  const permission = roleObj[resourceKey]; // e.g. "read" or "read/write"
  if (permission === "read/write") {
    return true;
  }

  // 4) If we get here, user doesn't have write permission
  if (showToast) {
    toast.error(`You only have '${permission}' access for '${resourceKey}'.`);
  }
  return false;
};

// Image Type Validate

interface ImageTypeValidateProps {
  allowedExtensions?: string[];
  allowedTypes?: string[];
  file: File;
  size?: number; // Size in megabytes
}

export const ImageTypeValidate = ({
  allowedExtensions = [".jpg", ".jpeg", ".png"],
  allowedTypes = ["image/png", "image/jpeg"],
  file,
  size = 5, // 5MB default limit
}: ImageTypeValidateProps): boolean => {
  let allowedExtensionsString = "";
  if (allowedExtensions?.length > 1) {
    allowedExtensionsString =
      allowedExtensions
        .slice(0, -1)
        .map((v) => v.replace(".", "").toUpperCase())
        .join(", ") +
      " and " +
      allowedExtensions[allowedExtensions.length - 1]
        .replace(".", "")
        .toUpperCase();
  } else {
    allowedExtensionsString = allowedExtensions
      ?.map((v) => v.replace(".", "").toUpperCase())
      .join(", ");
  }

  // Validate file type
  if (allowedTypes && allowedTypes.length > 0) {
    if (!allowedTypes.includes(file.type)) {
      toast.error(`Only ${allowedExtensionsString} files are allowed.`);
      return false;
    }
  }

  // Validate file extension
  if (allowedExtensions && allowedExtensions.length > 0) {
    const fileExtension = file.name
      .slice(file.name.lastIndexOf("."))
      .toLowerCase();
    if (!allowedExtensions.includes(fileExtension)) {
      toast.error(`Only ${allowedExtensionsString} files are allowed.`);
      return false;
    }
  }

  // Validate file size (convert MB to bytes: 1MB = 1,000,000 bytes)
  const maxSizeInBytes = size * 1000000;
  if (file.size > maxSizeInBytes) {
    toast.error(`File size exceeds the ${size}MB limit.`);
    return false;
  }

  return true;
};

export function truncate(str: string, length = 15) {
  str = str || "";
  if (str.length <= length) return str;
  return str.slice(0, length) + "...";
}

type InputType = "number" | "alphabets" | "alphanumeric";

const validationRules: Record<InputType, RegExp> = {
  number: /^[0-9]+$/,
  alphabets: /^[A-Za-z\s]+$/,
  alphanumeric: /^[A-Za-z0-9\s]+$/,
};

export function typeValidator(
  input: string,
  type: InputType,
  length?: number
): string {
  if (!input) {
    return "";
  }

  if (!validationRules[type].test(input)) {
    return "";
  }

  if (length !== undefined && input.length > length) {
    return input.slice(0, length);
  }

  return input;
}

export function generateDarkenColor(hex: string, factor = 0.2) {
  // Remove '#' if present
  hex = hex.replace(/^#/, "");

  // Validate hex code
  if (!/^[0-9A-Fa-f]{6}$/.test(hex)) {
    return hex; // Return original if invalid
  }

  // Convert hex to RGB
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);

  // Darken each RGB component
  const darkenedR = Math.round(r * (1 - factor));
  const darkenedG = Math.round(g * (1 - factor));
  const darkenedB = Math.round(b * (1 - factor));

  // Convert back to hex
  const darkenedHex = `#${(
    (1 << 24) +
    (darkenedR << 16) +
    (darkenedG << 8) +
    darkenedB
  )
    .toString(16)
    .slice(1)
    .toUpperCase()}`;

  return darkenedHex;
}

export const getHeaderHeight = () => {
  const header = document.querySelector("#main-website-header-container");
  if (header) {
    return header.clientHeight;
  }
  return 0;
};

export const getElementProperty = (selector: string): HTMLElement | null => {
  const ele = document.querySelector(selector);
  return ele instanceof HTMLElement ? ele : null;
};

export const getDrawerTitleHeight = () => {
  const header = document.querySelector("#drawwer-title");
  if (header) {
    return header.clientHeight;
  }
  return 60;
};

export const getAddressfromOBJS = (add: string | IAddressData | null) => {
  if (!add) return "Karachi, Pakistan";

  if (typeof add === "string") {
    return add;
  }

  return add?.streetAddress;
};

export const convertToKebabCase = (str?: string) => {
  if (!str) return "";
  return str
    .toLowerCase() // Convert to lowercase
    .replace(/[^a-z0-9]+/g, "-") // Replace all non-alphanumeric characters with -
    .replace(/^-+|-+$/g, ""); // Remove leading or trailing hyphens
};

export const generateMongoId = (): string => {
  const timestamp = Date.now().toString(16).padStart(8, "0"); // 8 chars timestamp
  const randomPart = Math.random().toString(16).slice(2, 8).padEnd(6, "0"); // 6 chars random
  const counter = Math.floor(Math.random() * 0xffffff)
    .toString(16)
    .padStart(6, "0"); // 6 chars counter
  return `${timestamp}${randomPart}${counter}`.slice(0, 24); // Ensure 24 chars
};

export const getGridSizeData = ({
  extraLarge = 6,
  large = 5,
  medium = 4,
  small = 2,
  rows = 3,
}: {
  extraLarge?: number;
  large?: number;
  medium?: number;
  small?: number;
  rows?: number;
}) => {
  let windowWidth = window.innerWidth;
  let gridCols = 6;
  let totalDataLength = 18;

  if (windowWidth >= 1536) {
    gridCols = extraLarge;
    totalDataLength = extraLarge * rows;
  } else if (windowWidth < 1536 && windowWidth >= 1076) {
    gridCols = large;
    totalDataLength = large * rows;
  } else if (windowWidth < 1076 && windowWidth >= 768) {
    gridCols = medium;
    totalDataLength = medium * rows;
  } else if (windowWidth < 768) {
    gridCols = small;
    totalDataLength = small * rows;
  }

  return {
    gridCols,
    totalDataLength,
  };
};

export const categorizeTimings = (data: TimeSlot[]) => {
  const morningSlots: TimeSlot[] = [];
  const afternoonSlots: TimeSlot[] = [];
  const eveningSlots: TimeSlot[] = [];

  data.forEach((slot) => {
    const fromTime = moment(slot.from, "HH:mm");
    const hour = fromTime.hour();

    if (hour >= 0 && hour < 12) {
      morningSlots.push(slot);
    } else if (hour >= 12 && hour < 18) {
      afternoonSlots.push(slot);
    } else if (hour >= 18 && hour <= 23) {
      eveningSlots.push(slot);
    }
  });

  // Sort each category by from time
  const sortByTime = (a: TimeSlot, b: TimeSlot) => {
    const timeA = moment(a.from, "HH:mm");
    const timeB = moment(b.from, "HH:mm");
    return timeA.diff(timeB);
  };

  morningSlots.sort(sortByTime);
  afternoonSlots.sort(sortByTime);
  eveningSlots.sort(sortByTime);

  return { morningSlots, afternoonSlots, eveningSlots };
};

export const GetBioMarkFilterIcons = (name: string): string => {
  let imagesPath = {
    OverAll: require("src/assets/images/FilterIcons/list-icon.png"),
    RespiratorySystem: require("src/assets/images/FilterIcons/respi-icon.png"),
    DigestiveSystem: require("src/assets/images/FilterIcons/digestive-icon.png"),
    CardiovascularSystem: require("src/assets/images/FilterIcons/cardio-icon.png"),
    ImmuneSystem: require("src/assets/images/FilterIcons/immunity-icon.png"),
    HarmonesSystem: require("src/assets/images/FilterIcons/harmones-icon.png"),
    VervousSystem: require("src/assets/images/FilterIcons/nerve-icon.png"),
    LiverSystem: require("src/assets/images/FilterIcons/liver-icon.png"),
    BloodSystem: require("src/assets/images/FilterIcons/blood.png"),
    UrogentialSystem: require("src/assets/images/FilterIcons/uro-icon.png"),
  };
  switch (name) {
    case "Respiratory System":
      return imagesPath.RespiratorySystem;
    case "Digestive System":
      return imagesPath.DigestiveSystem;
    case "Cardiovascular System":
      return imagesPath.CardiovascularSystem;
    case "Immune System":
      return imagesPath.ImmuneSystem;
    case "Hormones System":
      return imagesPath.HarmonesSystem;
    case "Nervous System":
      return imagesPath.VervousSystem;
    case "Liver System":
      return imagesPath.LiverSystem;
    case "Blood System":
      return imagesPath.BloodSystem;
    case "Urogenital System":
      return imagesPath.UrogentialSystem;
    default:
      return imagesPath.OverAll;
  }
};

export const handleAddressSelect = async (id: string, showToast = true) => {
  const { res, err } = await httpRequest<{ message: string }>({
    path: `/customer-address/current-select/${id}`,
    method: "put",
    params: {},
  });
  if (res) {
    if (showToast) {
      toast.success("Address changed successfully");
    }
    return true;
  } else {
    if (showToast) {
      toast.error(err?.message || "Something went wrong");
    }
    return false;
  }
};

export const handleGetSelectedAddress = async () => {
  const { res, err } = await httpRequest<{ data: IAddressData[] | null }>({
    path: `/customer-address/get-active-customer-addresss`,
    method: "get",
    params: {},
  });
  if (res) {
    return res?.data?.[0] || null;
  } else {
    return null;
  }
};

export const useWindowSize = () => {
  const width = window.innerWidth;
  const height = window.innerHeight;
  return { width, height };
};

export const checkAnyRedDot = (
  data: any,
  latestChat: ILatestChat[],
  role: string
) => {
  if (!data) return false;
  if (role === customer) {
    data = {
      ...data,
      adminPhysicalAppointment: 0,
      pharmacyOrder: 0,
      diagnosticOrderCustomer: 0,
      homeCareOrder: 0,
    };
  }
  return (
    Object.values(data).some((value: any) => value > 0) ||
    latestChat?.reduce(
      (acc: number, item: ILatestChat) => acc + item?.unRead || 0,
      0
    ) > 0
  );
};

export const parseQueryParams = (query: {
  [key: string]: string | number | boolean | string[] | number[];
}) => {
  let q = {};
  Object.entries(query).forEach(([key, value]) => {
    if (typeof value === "string" && value === "") {
      return;
    }
    if (Array.isArray(value) && value.length === 0) {
      return;
    }
    if (value === undefined || value === null) {
      return;
    }
    if (Array.isArray(value)) {
      q[key as keyof typeof q] = value
        .map((item) => encodeURIComponent(item))
        .join(",") as never;
    } else {
      q[key as keyof typeof q] = encodeURIComponent(value || "") as never;
    }
  });
  return qs.stringify(q);
};

/**
 * Validates that the selected date is not in the future.
 * @param {string | Date} date - The date to validate (string or Date object)
 * @returns {boolean} - Returns false if the date is in the future, true otherwise
 */
export function validateNotFutureDate(date: string | Date): boolean {
  let selectedDate: Date;
  if (typeof date === "string") {
    selectedDate = new Date(date);
  } else {
    selectedDate = date;
  }
  // Remove time part for comparison (set to midnight)
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  selectedDate.setHours(0, 0, 0, 0);

  if (selectedDate > today) {
    toast("Date cannot be in the future", { type: "error" });
    return false;
  }
  return true;
}

export const formateVitalData = (data: any) => {
  return {
    ...data,
    maleThresholds: {
      ref: {
        child: {
          low: {
            value: data?.maleThresholds?.ref?.child?.["0"],
          },
          high: {
            value: data?.maleThresholds?.ref?.child?.["1"],
          },
        },
        adult: {
          low: {
            value: data?.maleThresholds?.ref?.adult?.["0"],
          },
          high: {
            value: data?.maleThresholds?.ref?.adult?.["1"],
          },
        },
        elder: {
          low: {
            value: data?.maleThresholds?.ref?.elder?.["0"],
          },
          high: {
            value: data?.maleThresholds?.ref?.elder?.["1"],
          },
        },
      },
      op: {
        child: {
          low: {
            value: data?.maleThresholds?.op?.child?.["0"],
          },
          high: {
            value: data?.maleThresholds?.op?.child?.["1"],
          },
        },
        adult: {
          low: {
            value: data?.maleThresholds?.op?.adult?.["0"],
          },
          high: {
            value: data?.maleThresholds?.op?.adult?.["1"],
          },
        },
        elder: {
          low: {
            value: data?.maleThresholds?.op?.elder?.["0"],
          },
          high: {
            value: data?.maleThresholds?.op?.elder?.["1"],
          },
        },
      },
    },
    femaleThresholds: {
      ref: {
        child: {
          low: {
            value: data?.femaleThresholds?.ref?.child?.["0"],
          },
          high: {
            value: data?.femaleThresholds?.ref?.child?.["1"],
          },
        },
        adult: {
          low: {
            value: data?.femaleThresholds?.ref?.adult?.["0"],
          },
          high: {
            value: data?.femaleThresholds?.ref?.adult?.["1"],
          },
        },
        elder: {
          low: {
            value: data?.femaleThresholds?.ref?.elder?.["0"],
          },
          high: {
            value: data?.femaleThresholds?.ref?.elder?.["1"],
          },
        },
      },
      op: {
        child: {
          low: {
            value: data?.femaleThresholds?.op?.child?.["0"],
          },
          high: {
            value: data?.femaleThresholds?.op?.child?.["1"],
          },
        },
        adult: {
          low: {
            value: data?.femaleThresholds?.op?.adult?.["0"],
          },
          high: {
            value: data?.femaleThresholds?.op?.adult?.["1"],
          },
        },
        elder: {
          low: {
            value: data?.femaleThresholds?.op?.elder?.["0"],
          },
          high: {
            value: data?.femaleThresholds?.op?.elder?.["1"],
          },
        },
      },
    },
  };
};

export const getLoginUserID = (): string => {
  const token = getToken();
  if (!token) return "";
  const decodedToken = jwtDecode<ICustomJwtPayload>(token);
  return decodedToken?.id || "";
};

export const getLoginUserRole = (): string => {
  const token = getToken();
  if (!token) return "";
  const decodedToken = jwtDecode<ICustomJwtPayload>(token);

  return decodedToken?.userRole || "";
};

export const isProfileCompleted = (profile: ICustomJwtPayload , excludeFields: string[] = []) => {

  if (
    (!excludeFields.includes("firstName") ? profile?.firstName : true) &&
    (!excludeFields.includes("lastName") ? profile?.lastName : true) &&
    (!excludeFields.includes("number") ? profile?.number : true) &&
    (!excludeFields.includes("dob") ? profile?.dob : true) &&
    (!excludeFields.includes("email") ? profile?.email : true)
  ) {
    console.log("Profile Completed");
    return true;
  }
  console.log("Profile Not Completed");
  return false;
};

export const getNameFromEmail = (email: string) => {
  let name = email?.split("@")?.[0]?.replace(/[0-9]/g, "") || "";
  let nameArray =
    name?.split(".")?.map((word: string) => capitalize(word)) || [];
  let obj = {
    firstName: nameArray?.[0] || "",
    lastName: nameArray?.[1] || "",
  };
  return obj;
};

export const fetchChatList = async ({
  setIsLoader,
  dispatch,
}: {
  setIsLoader?: (isLoader: boolean) => void;
  dispatch: Dispatch<any>;
}) => {
  setIsLoader?.(true);
  let userRole = getLoginUserRole();
  if (!userRole) {
    return;
  }
  const { res, err } = await httpRequest<{ documents: ILatestChat[] }>({
    path: "/chat/list-all/users",
  });
  if (res) {
    let unread = res.documents.filter((item) => item.unRead > 0);
    unread.sort((a: ILatestChat, b: ILatestChat) => {
      const dateA = a.lastMessageTime
        ? new Date(a.lastMessageTime)
        : new Date(0);
      const dateB = b.lastMessageTime
        ? new Date(b.lastMessageTime)
        : new Date(0);
      return dateB.getTime() - dateA.getTime(); // Descending order
    });
    let read = res.documents.filter((item) => item.unRead === 0);
    read.sort((a: ILatestChat, b: ILatestChat) => {
      const dateA = a.lastMessageTime
        ? new Date(a.lastMessageTime)
        : new Date(0);
      const dateB = b.lastMessageTime
        ? new Date(b.lastMessageTime)
        : new Date(0);
      return dateB.getTime() - dateA.getTime(); // Descending order
    });

    dispatch(setChatList([...unread, ...read])); // Store fetched chat list in Redux state
  } else {
    toast(err, { type: "error" }); // Display error message if fetching fails
  }
  setIsLoader?.(false);
};

export const checkAnyChanges = (data: any, changes: any) => {
  return Object.keys(changes).some((key) => data[key] !== changes[key]);
};
